import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { api } from '../../../../api';
import {
    Button,
    Card,
    CardBody,
    Container,
    Row,
    Col,
    Form,
    FormGroup,
    InputGroupAddon,
    InputGroupText,
    Input,
    InputGroup,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Modal,
    ModalHeader,
    ModalBody,

} from "reactstrap";


import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Cookies from "js-cookie";


const Edittask2 = () => {
    const [modalOpen, setModalOpen] = useState(false);
    const [showAddClientModal, setShowAddClientModal] = useState(false); // New state for Add Project modal
    const [clientForm, setClientForm] = useState({});
    const [selectedSiteManagers, setSelectedSiteManagers] = useState([]);
    const [showSuccessAlert, setShowSuccessAlert] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');

    const toggleModal = () => setModalOpen(prevState => !prevState);
    const toggleAddClientModal = () => setShowAddClientModal(prevState => !prevState); // Function to toggle Add Project modal

    const { id } = useParams();
    const [updateValue, setupdateValues] = useState({
        status: '',
        id: id,
        p_id:'',
        emp_id : '',
        taskname: '',
        assign_to: [], // Changed to array for multi-select
        start_date: '',
        end_date: '',
        description: '',
        image: null
    })

    const [showAssignDropdown, setShowAssignDropdown] = useState(false);

    const company_id = Cookies.get('company_id');

    useEffect(() => {
        api
          .get("viewTask.php?t_id=" + id + "&company_id=" + company_id)
          .then((res) => {
            // Convert single assign_to to array for multi-select
            const assignToArray = res.data[0].assign_to ? [res.data[0].assign_to] : [];
            setupdateValues({
              ...updateValue,
              status: res.data[0].status,
              emp_id: res.data[0].emp_id,
              p_id: res.data[0].p_id,
              taskname: res.data[0].taskname,
              assign_to: assignToArray, // Store as array
              start_date: res.data[0].start_date,
              end_date: res.data[0].end_date,
              description: res.data[0].t_description,
              image: res.data[0].image,
            });
            // console.log(res.data);
            console.log(updateValue)
            // Fetch project data after task data is loaded
            fetchProjectData();
          })
          .catch((err) => console.log(err));
      }, [id]);

    const formData = new FormData();
    const handleSubmit = async (event) => {
        event.preventDefault();

        // Validate that at least one employee is selected
        if (updateValue.assign_to.length === 0) {
            alert('Please select at least one employee to assign the task to.');
            return;
        }

        try {
            
            formData.append('t_id', updateValue.id);
            formData.append('p_id', updateValue.p_id);
            formData.append('taskname', updateValue.taskname);
            formData.append('assign_to', updateValue.assign_to.join(',')); // Join array with commas
            formData.append('start_date', updateValue.start_date);
            formData.append('end_date', updateValue.end_date);
            formData.append('t_description', updateValue.description);
            formData.append('status', updateValue.status);
            formData.append('image', updateValue.image);
            formData.append('company_id', company_id);

            console.log(formData)

            

            const response = await api.post(`edittask.php`, formData);

            console.log("Data sent successfully:", response.data);

            // Show success message
            setSuccessMessage('Task updated successfully!');
            setShowSuccessAlert(true);
            setShowAssignDropdown(false); // Close dropdown
            
            // Redirect to task page after 3 seconds
            setTimeout(() => {
                window.location.href = '/site-admin/site-management/task2';
            }, 3000);
            
        } catch (error) {
            console.error("Error submitting data:", error);
        }
        
    };

    

    const [searchQuery, setSearchQuery] = useState('');
    const [filteredEmployees, setFilteredEmployees] = useState([]);
    const [selectedManager, setSelectedManager] = useState('');
    const [selectedLocation, setSelectedLocation] = useState('');




    const toggleDropdown = (employeeId) => {
        setFilteredEmployees(prevEmployees => prevEmployees.map(employee => {
            if (employee.id === employeeId) {
                return { ...employee, dropdownOpen: !employee.dropdownOpen };
            }
            return employee;
        }));
    };

    // Function to filter employees based on search query
    const filterEmployees = () => {
        if (!searchQuery) {
            setFilteredEmployees(employees);
        } else {
            const filtered = employees.filter(employee =>
                employee.name.toLowerCase().includes(searchQuery.toLowerCase())
            );
            setFilteredEmployees(filtered);
        }
    };



   



    const handleManagerSelectChange = (selectedOption) => {
        setSelectedManager(selectedOption);
    };

    const handleLocationSelectChange = (selectedOption) => {
        setSelectedLocation(selectedOption);
    };

    const handleSiteManagerSelectChange = (selectedOptions) => {
        setSelectedSiteManagers(selectedOptions);
        setClientForm(prevState => ({
            ...prevState,
            siteManagers: selectedOptions.map(option => option.value)
        }));
    };

    const statusOptions = [
        { value: 'to-do', label: 'to-do' },
        { value: 'in-progress', label: 'in-progress' },
        { value: 'completed', label: 'completed' }
    ];


    const [employees, setemployees] = useState();
    const fetchEmployeeData = async () => {
        try {
            const response = await api.get(`employeesView.php?company_id=${company_id}`);
            setemployees(response.data);

        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    useEffect(() => {
        fetchEmployeeData();
    }, []);


    const handleMultiSelectEmployee = (employeeId, employeeName) => {
        setupdateValues((prevState) => {
            const currentSelected = [...prevState.assign_to];
            const employeeIdStr = employeeId.toString();
            
            if (currentSelected.includes(employeeIdStr)) {
                // Remove if already selected
                return {
                    ...prevState,
                    assign_to: currentSelected.filter(id => id !== employeeIdStr)
                };
            } else {
                // Add if not selected
                return {
                    ...prevState,
                    assign_to: [...currentSelected, employeeIdStr]
                };
            }
        });
    };

    const getSelectedEmployeeNames = () => {
        if (!employees || !Array.isArray(employees)) return "Select Assign To";
        
        const selectedNames = updateValue.assign_to.map(id => {
            const employee = employees.find(emp => emp.emp_id.toString() === id);
            return employee ? employee.emp_name : '';
        }).filter(name => name !== '');
        
        return selectedNames.length > 0 ? selectedNames.join(', ') : "Select Assign To";
    };

    const isEmployeeSelected = (employeeId) => {
        return updateValue.assign_to.includes(employeeId.toString());
    };

    const handleStatusChange = (event) => {
        setupdateValues({ ...updateValue, status: event.target.value });
    };
    
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setupdateValues((prevState) => ({
          ...prevState,
          [name]: value,
        }));
        console.log(updateValue);
      };
    
      const handleFileChange = (e) => {
        const file = e.target.files[0];
        formData.append('files', file);
      };

    const [project, setproject] = useState([]);
    const fetchProjectData = async () => {
        try {
            // Get the site manager ID from the task data
            const siteManagerId = updateValue.emp_id;
            if (siteManagerId) {
                const response = await api.get(`viewProjectDetails.php?s_m_id=${siteManagerId}&company_id=${company_id}`);
                setproject(response.data);
                console.log(response.data);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

     // Update filtered employees when searchQuery changes
     useEffect(() => {
        filterEmployees();
    }, [searchQuery]);

    // Fetch project data when site manager ID is available
    useEffect(() => {
      if (updateValue.emp_id) {
        fetchProjectData();
      }
    }, [updateValue.emp_id]);


    return (
        <>
            <div className="header bg-gradient-info py-7 py-lg-8">
                <Col className="order-xl-2 mb-5 mb-xl-0 text-center  mb-5">
                    <h1>Edit Task Details</h1>
                </Col>
                <Link to="/site-admin/site-management/task2"> <Button className='ml-5' style={{backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black'}}>Back</Button></Link>
                <Container className="py-4 ">
                    <div className="p-4 rounded" style={{boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)', backgroundColor: '#fff', borderRadius: '15px'}}>

                        <Row className='px-3'>
                        <Col md={12}>
                                                            <FormGroup>
                                                                <label className="form-control-label" htmlFor="input-status">Project Name</label>
                                                                <Input
                                                                    className="form-control-alternative"
                                                                    id="input-status"
                                                                    type="select"
                                                                    name="p_id"
                                                                    value={updateValue.p_id}
                                                                    onChange={handleInputChange}
                                                                >
                                                                    <option value="">Select Project</option>
                                                                    {project && Array.isArray(project) && project.map(option => (
                                                                        <option key={option.p_id} value={option.p_id}>{option.p_name}</option>
                                                                    ))}
                                                                </Input>
                                                            </FormGroup>
                                                        </Col>
                            <Col md={12}>
                                <FormGroup>
                                    <label className="form-control-label" htmlFor="input-status">Task Status</label>
                                    <Input
                                        className="form-control-alternative"
                                        id="input-status"
                                        type="select"
                                        name="status"
                                        onChange={handleStatusChange}
                                        value={updateValue.status}
                                    >
                                        {statusOptions.map(option => (
                                            <option key={option.value} value={option.value}>{option.label}</option>
                                        ))}
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md={12}>
                                <FormGroup>
                                    <label className="form-control-label" htmlFor="input-name">Task Name</label>
                                    <Input
                                        className="form-control-alternative"
                                        id="input-name"
                                        type="text"
                                        name="taskname"
                                        defaultValue={updateValue.taskname}
                                        placeholder='Project Name'
                                        onChange={handleInputChange}
                                    />
                                </FormGroup>
                            </Col>

                            <Col md={12}>
                                <FormGroup>
                                    <label className="form-control-label" htmlFor="input-manager">Select Assign To</label>
                                    <div style={{ position: 'relative' }}>
                                        <div
                                            className="form-control-alternative"
                                            style={{
                                                cursor: 'pointer',
                                                minHeight: '38px',
                                                padding: '8px 12px',
                                                border: '1px solid #d1d3e2',
                                                borderRadius: '0.375rem',
                                                backgroundColor: '#fff',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between'
                                            }}
                                            onClick={() => setShowAssignDropdown(!showAssignDropdown)}
                                        >
                                            <span style={{ 
                                                color: updateValue.assign_to.length > 0 ? '#333' : '#6c757d',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap'
                                            }}>
                                                {getSelectedEmployeeNames()}
                                            </span>
                                            <i className={`fas fa-chevron-${showAssignDropdown ? 'up' : 'down'}`}></i>
                                        </div>
                                        
                                        {showAssignDropdown && (
                                            <div style={{
                                                position: 'absolute',
                                                top: '100%',
                                                left: 0,
                                                right: 0,
                                                backgroundColor: '#fff',
                                                border: '1px solid #d1d3e2',
                                                borderRadius: '0.375rem',
                                                boxShadow: '0 0.5rem 1rem rgba(0, 0, 0, 0.15)',
                                                zIndex: 1000,
                                                maxHeight: '200px',
                                                overflowY: 'auto'
                                            }}>
                                                {employees && Array.isArray(employees) && employees.map((employee) => (
                                                    <div
                                                        key={employee.emp_id}
                                                        style={{
                                                            padding: '8px 12px',
                                                            cursor: 'pointer',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            borderBottom: '1px solid #f8f9fa'
                                                        }}
                                                        onClick={() => handleMultiSelectEmployee(employee.emp_id, employee.emp_name)}
                                                        onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                                                        onMouseLeave={(e) => e.target.style.backgroundColor = '#fff'}
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            checked={isEmployeeSelected(employee.emp_id)}
                                                            onChange={() => {}} // Handle change in onClick
                                                            style={{ marginRight: '8px' }}
                                                        />
                                                        <span>{employee.emp_name}</span>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                    {updateValue.assign_to.length === 0 && (
                                        <small style={{ color: 'red' }}>Please select at least one employee</small>
                                    )}
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <label className="form-control-label" htmlFor="input-starting">Task Starting Date</label>
                                    <Input
                                        className="form-control-alternative"
                                        id="input-starting"
                                        type="datetime-local"
                                        name="start_date"
                                        defaultValue={updateValue.start_date}
                                        onChange={handleInputChange}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <label className="form-control-label" htmlFor="input-ending">Task Ending Date</label>
                                    <Input
                                        className="form-control-alternative"
                                        id="input-ending"
                                        type="datetime-local"
                                        name="end_date"
                                        defaultValue={updateValue.end_date}
                                        onChange={handleInputChange}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={12}>
                                <FormGroup>
                                    <label className="form-control-label" htmlFor="input-description">Project Description</label>
                                    <CKEditor
                                        editor={ClassicEditor}
                                        data={updateValue.description}
                                        onChange={(event, editor) => {
                                            const data = editor.getData(); // Corrected: Use editor.getData() instead of event.data
                                            setupdateValues(prevState => ({
                                                ...prevState,
                                                description: data // Corrected: Use t_description to update the description field
                                            }));
                                        }}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <label className="form-control-label" htmlFor="input-file">Upload File</label>
                                    <Input
                                        type="file"
                                        className="form-control-file"
                                        id="input-file"
                                        name="file"
                                        
                                        onChange={handleFileChange}
                                    />
                                    {updateValue.image && (
                                    <h4>Old file: {updateValue.image}</h4>
                                    )}
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg='12' className='text-center mb-2'>
                                <Button  type="submit" onClick={handleSubmit} style={{backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black'}}>Submit</Button>
                            </Col>
                        </Row>
                    </div>
                </Container>


            </div>

            {showSuccessAlert && (
              <div style={{
                position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
                justifyContent: 'center', alignItems: 'flex-start', paddingTop: '15%', zIndex: 9999
              }}>
                <div style={{
                  backgroundColor: '#fff', padding: '30px', borderRadius: '15px',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.3)', textAlign: 'center',
                  maxWidth: '400px', width: '90%', border: '3px solid #d86f89'
                }}>
                  <div style={{ fontSize: '48px', color: '#d86f89', marginBottom: '20px' }}>✓</div>
                  <h4 style={{ color: '#28a745', marginBottom: '15px' }}>Success!</h4>
                  <p style={{ color: '#333', fontSize: '16px', marginBottom: '20px' }}>{successMessage}</p>
                  <Button
                    style={{
                      backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'white',
                      padding: '10px 25px', borderRadius: '25px'
                    }}
                    onClick={() => setShowSuccessAlert(false)}
                  >OK</Button>
                </div>
              </div>
            )}

        </>
    );
};

export default Edittask2;